module.exports = __webpack_public_path__ + "static/media/photo106.a1ca9206.jpg";